import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {getParam} from '../question-helper';

@Component({
    selector: 'app-question-interstitial-generic',
    templateUrl: './question-interstitial-generic.component.html',
    styleUrls: ['./question-interstitial-generic.component.scss'],
    standalone: false
})
export class QuestionInterstitialGenericComponent implements OnInit {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();
  agree: any = false;
  parameter: any;
  showAgree: boolean = false;
  constructor() { }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    
    if (getParam(this.parameter, 'checkBox')?.value === '1') {
      this.showAgree = true;
    }
  }
  setAgree(): void {
    this.question.answer = this.agree.toString();
    if (this.question.answer === 'true') {
      this.questionAnswer.emit(this.question);
    }
    else {
      this.question.answer = null;
      this.questionAnswer.emit(this.question);
    }
  }

}
